import { render, staticRenderFns } from "./ItemsFiltering.vue?vue&type=template&id=1917dc86&"
import script from "./ItemsFiltering.vue?vue&type=script&lang=js&"
export * from "./ItemsFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports